"use client";

import { useCallback, useEffect, useRef } from "react";

const MAX_PRESIGNED_IMAGE_RETRIES = 2;

/**
 * Refetch presigned media when the browser fails to load a cached URL (typically expired).
 */
export function usePresignedImageErrorRecovery(
  url: string | null | undefined,
  onRecover: () => void | Promise<unknown>,
) {
  const retryCountRef = useRef(0);

  useEffect(() => {
    retryCountRef.current = 0;
  }, [url]);

  return useCallback(() => {
    if (retryCountRef.current >= MAX_PRESIGNED_IMAGE_RETRIES) return;
    retryCountRef.current += 1;
    void onRecover();
  }, [onRecover]);
}
